export const CREATOR_HOUSE = {
  page: "creator-house-page",
  heroEyebrow: "ch-hero-eyebrow",
  heroTitle: "ch-hero-title",
  heroCta: "ch-hero-cta",
  transformationTitle: "ch-transformation-title",
  weeksTitle: "ch-weeks-title",
  weekCard: (n) => `ch-week-card-${n}`,
  biggerPictureTitle: "ch-bigger-picture-title",
  walkAwayTitle: "ch-walkaway-title",
  includedTitle: "ch-included-title",
  whoTitle: "ch-who-title",
  finalTitle: "ch-final-title",
  finalCta: "ch-final-cta",
  checkoutError: "ch-checkout-error",
  joinDialog: "ch-join-dialog",
  joinFirstName: "ch-join-first-name",
  joinEmail: "ch-join-email",
  joinSubmit: "ch-join-submit",
  joinError: "ch-join-error",
};

export const PAYMENT = {
  successPage: "payment-success-page",
  cancelPage: "payment-cancel-page",
  successBackCta: "payment-success-back-cta",
  cancelBackCta: "payment-cancel-back-cta",
  cancelRetryCta: "payment-cancel-retry-cta",
};

export const ADMIN = {
  page: "admin-orders-page",
  gate: "admin-gate",
  passcodeInput: "admin-passcode-input",
  unlockBtn: "admin-unlock-btn",
  gateError: "admin-gate-error",
  table: "admin-orders-table",
  row: (i) => `admin-order-row-${i}`,
  empty: "admin-orders-empty",
  logout: "admin-logout-btn",
  refresh: "admin-refresh-btn",
  exportBtn: "admin-export-btn",
};
